import React from 'react'
import { Box, Group, Stack, Table, Title } from '@mantine/core'
import Image from 'next/image'

type Props = {
  title: string
  icon: any
  children: React.ReactNode
}

const FeatureTable = ({ title, icon, children }: Props) => {
  return (
    <Stack spacing={0}>
      <Group spacing="sm" my="md">
        <Box w={24} h={24} ml={24}>
          <Image src={icon.src} alt="platform" width={24} height={24} />
        </Box>
        <Title order={3}>{title}</Title>
      </Group>
      <Table
        horizontalSpacing={16}
        sx={{
          'tbody tr:last-of-type td': {
            borderBottom: '1px solid rgba(227, 229, 232, 0.6)',
          },
          'tbody tr td': {
            padding: '16px 0',
            fontSize: '16px',
            borderBottom: '1px solid rgba(227, 229, 232, 0.6)',
          },
          'tbody tr td:first-of-type': {
            paddingLeft: '24px',
            color: '#495057',
          },
        }}
      >
        <tbody>{children}</tbody>
      </Table>
    </Stack>
  )
}

export default FeatureTable
